var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block list"},[_c('button',{staticClass:"btn btn-default btn-block",attrs:{"type":"button"},on:{"click":_vm.removeIssue}},[_vm._v("\n    Remove from board\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }